/**
 * User: liliana
 * Date: 1/6/15
 * Time: 2:22 PM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */

'use strict';

// ---------------------------------------------------
// Module Definition

var pointerEvents = module.exports;

// ---------------------------------------------------
// Dependencies

var _ = require('underscore');

// ---------------------------------------------------
// Define Module Static Properties

_.extend(pointerEvents, {
    // TOUCH ACTION ATTRIBUTE VALUES
    // To receive pointerevents, touch-action property must be set on targeted element
    // https://github.com/jquery/PointerEvents
    TOUCH_ACTION_ATTR: 'touch-action',
    TOUCH_ACTION_NONE: 'none',
    TOUCH_ACTION_PAN_X: 'pan x',
    TOUCH_ACTION_PAN_Y: 'pan y',
    TOUCH_ACTION_PAN_X_Y: 'pan-x pan-y',
    TOUCH_ACTION_SCROLL: 'scroll',

    // POINTER TYPE VALUES (IE11+)
    POINTER_TYPE_TOUCH: 'touch',
    POINTER_TYPE_PEN: 'pen',
    POINTER_TYPE_MOUSE: 'mouse',

    /**
     * Returns true if pointer originated from touch input
     * @param {object} e
     * @returns {boolean}
     */
    isTouch: function(e) {
        return this.getPointerType(e.pointerType) === this.POINTER_TYPE_TOUCH;
    },

    /**
     * Returns true if pointer originated from pen input
     * @param {object} e
     * @returns {boolean}
     */
    isPen: function(e) {
        return this.getPointerType(e.pointerType) === this.POINTER_TYPE_PEN;
    },

    /**
     * Returns true if pointer originated from mouse input
     * @param {object} e
     * @returns {boolean}
     */
    isMouse: function(e) {
        return this.getPointerType(e.pointerType) === this.POINTER_TYPE_MOUSE;
    },

    /**
     * Gets pointerType from event object, abstracts IE10 return type of long for pointerType property
     * {@link http://msdn.microsoft.com/en-us/library/ie/hh772359(v=vs.85).aspx|MSDN pointerType property}
     * @param {string|long} pointerType
     * @returns {string|null}
     */
    getPointerType: function(pointerType) {
        var type;

        switch (pointerType) {
            case this.POINTER_TYPE_TOUCH:
            case 0x00000002:
                type = this.POINTER_TYPE_TOUCH;
                break;
            case this.POINTER_TYPE_PEN:
            case 0x00000003:
                type = this.POINTER_TYPE_PEN;
                break;
            case this.POINTER_TYPE_MOUSE:
            case 0x00000004:
                type = this.POINTER_TYPE_MOUSE;
                break;
            default:
                type = null;
        }

        return type;
    },
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/pointerEvents.js
// module id = 4176
// module chunks = 62